/* Premium tooltip for Recharts.
   Black bg / white text, soft shadow, rounded, optionally shows percentage.
   Works seamlessly in light and dark mode (it's always dark, by design).
*/
import MoneyAmount from "@/components/MoneyAmount";

export default function ChartTooltip({
  active,
  payload,
  label,
  currency = "USD",
  totalForPercent,
  valueLabel,
}) {
  if (!active || !payload || !payload.length) return null;

  // Pie/donut: payload[i].payload has {name, value, color}
  // Bar/Area: payload[i] has {dataKey, value, color, name}
  return (
    <div
      role="tooltip"
      className="rounded-[12px] border border-white/10 bg-[#111111] px-3.5 py-2.5 text-white shadow-2xl"
      style={{ minWidth: 140, boxShadow: "0 12px 32px rgba(0,0,0,0.35)" }}
    >
      {label && (
        <div className="mb-1.5 text-[11px] font-medium uppercase tracking-widest text-[#E5E7EB]/70">
          {label}
        </div>
      )}
      <div className="space-y-1.5">
        {payload.map((p, i) => {
          const name = p.name || p.payload?.name || p.dataKey;
          const value = Number(p.value ?? p.payload?.value ?? 0);
          const color = p.color || p.payload?.color || p.fill || "#fff";
          const pct =
            totalForPercent && totalForPercent > 0
              ? (value / totalForPercent) * 100
              : null;
          return (
            <div key={i} className="flex items-center gap-2.5">
              <span
                aria-hidden="true"
                className="inline-block h-2.5 w-2.5 flex-shrink-0 rounded-full"
                style={{ backgroundColor: color }}
              />
              <div className="min-w-0 flex-1">
                <div className="text-[13px] font-semibold leading-tight text-white">
                  {name}
                </div>
                <div className="text-[12px] font-medium leading-tight text-[#E5E7EB]">
                  <MoneyAmount value={value} currency={currency} tone="neutral" />
                  {pct != null && (
                    <span className="ml-1 text-[#E5E7EB]/70">({pct.toFixed(1)}%)</span>
                  )}
                  {valueLabel && (
                    <span className="ml-1 text-[#E5E7EB]/70">{valueLabel}</span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
